// extracted by mini-css-extract-plugin
export default {"ellipsis":"Spinner_ellipsis__6f9Nu","ellipsis1":"Spinner_ellipsis1__nc+4F","ellipsis2":"Spinner_ellipsis2__pkC7f","ellipsis3":"Spinner_ellipsis3__G0Bb+"};